import { Pipe, PipeTransform } from '@angular/core';
import { values } from 'ramda';

@Pipe({
    name: 'values',
    standalone: false
})
export class ValuesPipe implements PipeTransform {
  transform(object): any[] {
    return values(object);
  }
}
